import { createContext, useContext } from 'react'
import { AccountingCustomerCompany } from '@/types/customer-context'

export type ProductContextValue = {
  product: 'accounting' | 'credit'
  companies: AccountingCustomerCompany[]
  personName: string
  personTaxId: string | null
  firstName: string
  hasAccounting: boolean
  hasCredit: boolean
  accountingLoading: boolean
  accountingAvailable: boolean
  creditAvailable: boolean
  creditHasPending: boolean
  selectedCompanyKey: string | null
  sheetOpen: boolean
  welcome: boolean
  tipOpen: boolean
  openSheet: () => void
  closeSheet: () => void
  dismissTip: () => void
  selectCredit: () => void
  selectCompany: (company: AccountingCustomerCompany) => void
}

export const ProductContext = createContext<ProductContextValue | null>(null)

export function useProduct() {
  const context = useContext(ProductContext)
  if (!context) {
    throw new Error('useProduct was used outside of its Provider')
  }
  return context
}
